"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyle = void 0;
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
var getStyle = function (disabled) { return ({
    controlBtn: react_1.css({
        outline: 'none',
        border: 'none',
        backgroundColor: 'inherit',
        padding: 0,
        display: 'grid',
        placeItems: 'center',
        color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")",
        ':hover:enabled, :focus:enabled': {
            color: "var(" + variables_1.RootColor.Blue.DEFAULT + ")",
        },
        ':active:enabled': {
            color: "var(" + variables_1.RootColor.Blue.DARK_1 + ")",
        },
    }),
    iconStyle: react_1.css({
        paddingLeft: 5,
        paddingRight: 5,
        cursor: disabled ? 'not-allowed' : 'pointer',
    }),
    input: react_1.css({
        width: 90,
        paddingRight: 0,
        position: 'relative',
        'input': {
            MozAppearance: 'textfield',
            '::-webkit-outer-spin-button, ::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
            },
        },
        '.controlButton': {
            // padding: '0 5px',
            cursor: disabled ? 'not-allowed' : 'pointer',
        },
        '.buttonGroup': {
            opacity: 0,
            borderLeft: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            backgroundColor: 'inherit',
            width: 0,
            marginLeft: -8,
            right: 0,
        },
        ':hover .buttonGroup': {
            width: 'auto',
            opacity: 1,
        },
        ':focus-within .buttonGroup': {
            width: 'auto',
            opacity: 1,
        },
    }),
    before: react_1.css({
        borderRight: '1px solid ' + style_1.SixsenseColor.Gray.LIGHT_3,
    }),
    after: react_1.css({
        borderLeft: '1px solid ' + style_1.SixsenseColor.Gray.LIGHT_3,
    }),
    up: react_1.css({
        borderBottom: '0.5px solid ' + style_1.DesignSystemThemeColor.Gray.LIGHT_2,
        height: '50%',
    }),
    down: react_1.css({
        borderTop: '0.5px solid ' + style_1.DesignSystemThemeColor.Gray.LIGHT_2,
        height: '50%',
    }),
}); };
exports.getStyle = getStyle;
